var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-img',{staticStyle:{"max-width":"200px","max-height":"200px","height":"100%","width":"100%"},attrs:{"src":("/img/icons/diving/" + _vm.icon + ".svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }